<template>
  <div v-if="hasFeaturesData">
    <div class="asc-analytic-form-features-table">
      <div class="asc-div-table">
        <div class="asc-div-table--heading">
          <template v-if="featuresDefinition && featuresDefinition.headings">
            <div
              v-for="(header, rIndex) in featuresDefinition.headings"
              :key="rIndex"
              class="asc-div-table--row-cell"
            >
              <span class="asc-div-table--row-cell-span">{{ header }}</span>
            </div>
          </template>
        </div>
        <template v-if="featuresDefinition.values">
          <div
            v-for="(row, rIndex) in featuresDefinition.values"
            :key="rIndex"
            class="asc-div-table--row"
          >
            <div class="asc-div-table--row-cell">
              <div class="asc-div-table--row-cell-name">
                {{ row.name }}
              </div>
            </div>
            <div class="asc-div-table--row-cell">
              <textarea
                class="asc-div-table--row-cell-featureName"
                spellcheck="false"
                :value="row.displayName"
                maxlength="255"
                @input="updateFeatureName(rIndex, $event.target.value)"
              ></textarea>
              <v-icon
                :size="16"
                :color="getColor"
                class="asc-div-table--row-cell-icon"
                >edit</v-icon
              >
            </div>
            <div class="asc-div-table--row-cell">
              <div class="asc-div-table--row-cell-checkbox">
                <asc-checkbox
                  v-model="row.isUserPlottable"
                  :checked="row.isUserPlottable"
                  @change="updateFeaturesFlag(rIndex, row.isUserPlottable)"
                />
              </div>
            </div>
            <div class="asc-div-table--row-cell">
              <div class="asc-div-table--row-cell-checkbox">
                <asc-checkbox
                  v-model="row.isPrivate"
                  :checked="row.isPrivate"
                  @change="updateFeaturePrivate(rIndex, row.isPrivate)"
                />
              </div>
            </div>
            <div class="asc-div-table--row-cell">
              <div class="asc-div-table--row-cell-checkbox">
                <asc-checkbox
                  v-model="row.isRiskScore"
                  :checked="row.isRiskScore"
                  :disabled="true"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AscCheckbox from '@/components/atoms/AscCheckbox'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscAnalyticVisualizationTable',

  components: {
    AscCheckbox,
  },

  props: {
    features: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      featuresDefinition: {
        headings: [
          'Visualization Internal Name',
          'Visualization Display Name',
          'Visualize?',
          'Internal Only?',
          'Risk Score?',
        ],
        values: this.features,
      },
    }
  },

  computed: {
    hasFeaturesData() {
      return (
        this.featuresDefinition.values !== undefined &&
        this.featuresDefinition.values.length
      )
    },
    getColor() {
      return variables.gray600
    },
  },

  methods: {
    getFeaturesName(index) {
      return this.features[index].displayName
    },
    getFeaturesEnabled(index) {
      return this.features[index].isUserPlottable
    },
    updateFeaturesFlag(index, isUserPlottable) {
      const newData = {
        feature: {
          ...this.features[index],
          isUserPlottable,
        },
        index: index,
      }
      this.$emit('update-feature', newData)
    },
    updateFeaturePrivate(index, isPrivate) {
      const newData = {
        feature: {
          ...this.features[index],
          isPrivate: isPrivate,
        },
        index: index,
      }
      this.$emit('update-feature', newData)
    },
    updateFeatureName(index, value) {
      const newData = {
        feature: {
          ...this.features[index],
          displayName: value,
        },
        index: index,
      }
      this.$emit('update-feature', newData)
    },
  },
}
</script>

<style lang="scss">
.asc-div-table {
  display: table;
  width: 100%;
  font-size: 12px;
  border: 1px solid $gray-400;
  max-width: 990px;

  &--heading {
    display: table-row;
    background-color: $gray-300;
  }

  &--row {
    display: table-row;

    &-cell {
      display: table-cell;
      padding: 3px;
      margin: 3px;
      max-width: 250px;
      vertical-align: top;

      &-name {
        font-size: 12px;
        width: 250px;
        resize: none;
        padding-top: 0;
      }

      &-featureName {
        font-size: 12px;
        width: 250px;
        height: auto;
        resize: none;

        &:focus {
          outline: 2px solid $accent-600;
        }
      }

      &-icon {
        float: left;
        display: none !important;
        padding: 0;
      }

      &-span {
        margin: 4px 0;
        display: inline-block;
        padding-left: 5px;
      }

      &-checkbox {
        float: right;
        display: flex;
        height: 24px;
        padding-top: 10px;
        // margin: 5px 0 0 0;
        width: 60px;
      }
    }
  }
}

// prettier-ignore
.asc-div-table--row-cell-featureName:hover + .asc-div-table--row-cell-icon {
  display: inline-block !important;
}

.asc-analytic-form-features-table {
  padding-bottom: 10px;
}
</style>
